var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsEnum, IsNotEmpty, IsString } from 'class-validator';
import { EmbedBookingVerifyStatus } from '../enums/embed-booking-verify-status.enum.js';
/**
 * The one-time email confirmation token a website visitor clicks (PRD #1358,
 * RS-004). The token is the ONLY credential on the public verify route — it is
 * a signed `{ appointmentId, exp }` payload, so no embed session is needed (the
 * confirmation page lives on our origin, outside the iframe). The office
 * location is never accepted from the caller: the token's appointment id is the
 * only scope.
 */
export class VerifyEmbedBookingDto {
    token;
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], VerifyEmbedBookingDto.prototype, "token", void 0);
/** The confirmation page's read of the verify outcome. Carries no medical content. */
export class EmbedBookingVerifyResponseDto {
    status;
}
__decorate([
    IsEnum(EmbedBookingVerifyStatus),
    __metadata("design:type", String)
], EmbedBookingVerifyResponseDto.prototype, "status", void 0);
//# sourceMappingURL=verify-embed-booking.dto.js.map